import React, { useState } from 'react';

import './styles.scss';
import { useTranslation } from '@/hooks/useTranslations';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ = ({ config }: { config: FAQItem[] }) => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle open/close
  };

  return (
    <div className="faq-wrapper">
      <h1 className="avi-page-title">{t('Avi-FAQ-Title')}</h1>
      <div className="faq-holder">
        {config.map((item, index) => (
          <div key={index} className={`faq-row-info-wrp ${openIndex === index ? 'active' : ''}`}>
            <div className="faq-row-info-inner" onClick={() => toggleFAQ(index)}>
              <p className="faq-row-info-title">{t(item.question)}</p>
              <div className="faq-row-info-circle">
                <i className={`bc-i-plus ${openIndex === index ? 'hidden' : ''} plus-for-faq`} />
                <i className={`bc-i-minus ${openIndex === index ? '' : 'hidden'} minus-for-faq`} />
              </div>
            </div>
            {openIndex === index && (
              <div className="faq-row-open-info-wrp">
                <div className="faq-row-open-info-holder">
                  <div className="faq-row-open-info-inner">
                    <p className="faq-row-open-info-txt">{t(item.answer)}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
